//Boilerplate
import { withRouter } from "tools/routerCompat";

//OurStuff
import { RoleRights } from 'components/User';
export default withRouter((RoleRights));
